(function(){
  'use strict';
  const STORAGE_KEY='layl-wishlist-v1';
  const dictionary=(()=>{
    try{return JSON.parse(document.getElementById('layl-wishlist-i18n')?.textContent||'{}')}
    catch{return {}}
  })();
  const label=(key,fallback)=>dictionary[key]||fallback;
  const icon='<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"><path d="M20.3 5.9a5.4 5.4 0 0 0-7.6 0L12 6.6l-.7-.7a5.4 5.4 0 0 0-7.6 7.6L12 21l8.3-7.5a5.4 5.4 0 0 0 0-7.6Z"/></svg>';
  function load(){
    try{const v=JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]');return Array.isArray(v)?v.filter(i=>i&&i.id&&i.url&&i.title).slice(0,100):[]}
    catch{return []}
  }
  let favorites=load();
  const byId=id=>favorites.some(x=>String(x.id)===String(id));
  const save=()=>{try{localStorage.setItem(STORAGE_KEY,JSON.stringify(favorites))}catch(e){console.warn('Wishlist storage unavailable',e)}};
  const dialog=()=>document.getElementById('layl-wishlist-dialog');
  function refresh(){
    document.querySelectorAll('[data-layl-wishlist-count]').forEach(e=>{e.textContent=favorites.length;e.hidden=!favorites.length});
    document.querySelectorAll('[data-layl-heart-id]').forEach(b=>{const active=byId(b.dataset.laylHeartId);b.dataset.active=String(active);b.setAttribute('aria-pressed',String(active));b.setAttribute('aria-label',active?label('removeFavorite','Remove from favourites'):label('addFavorite','Save to favourites'))});
    render();
  }
  function itemFrom(el){
    const d=el.dataset;
    return {id:d.laylProductId,title:d.laylProductTitle,url:d.laylProductUrl,image:d.laylProductImage||'',price:d.laylProductPrice||''};
  }
  function toggle(item){
    if(!item.id||!item.url)return;
    if(byId(item.id))favorites=favorites.filter(x=>String(x.id)!==String(item.id));
    else favorites.unshift(item);
    save();refresh();
  }
  function createHeart(item,inline){
    const b=document.createElement('button');
    b.type='button';b.className='layl-wishlist-heart'+(inline?' layl-wishlist-product-button layl-product-page-heart':'');
    b.dataset.laylHeartId=String(item.id);
    b.innerHTML=icon;
    b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();toggle(item)});
    return b;
  }
  function decorate(){
    document.querySelectorAll('product-card[data-layl-product-id]').forEach(el=>{
      if(el.querySelector('[data-layl-heart-id]'))return;
      el.append(createHeart(itemFrom(el),false));
    });
    document.querySelectorAll('a.layl-product-card[data-layl-product-id]').forEach(el=>{
      if(el.parentElement?.classList.contains('layl-product-shell'))return;
      const wrap=document.createElement('div');wrap.className='layl-product-shell';
      el.parentNode.insertBefore(wrap,el);wrap.append(el);wrap.append(createHeart(itemFrom(el),false));
    });
    const current=document.querySelector('[data-layl-current-product]');
    if(current&&!document.querySelector('.layl-product-page-heart')){
      const title=document.querySelector('main .product-information h1, main .product-title, main h1');
      if(title)title.insertAdjacentElement('afterend',createHeart(itemFrom(current),true));
    }
    refresh();
  }
  function node(tag,cls,txt){
    const el=document.createElement(tag);
    if(cls)el.className=cls;
    if(txt!==undefined)el.textContent=txt;
    return el;
  }
  function render(){
    const list=document.getElementById('layl-wishlist-items');
    const empty=document.getElementById('layl-wishlist-empty');
    if(!list||!empty)return;
    list.replaceChildren();
    empty.hidden=favorites.length>0;list.hidden=favorites.length===0;
    document.querySelectorAll('[data-layl-wishlist-total]').forEach(e=>e.textContent=favorites.length?'('+favorites.length+')':'');
    favorites.forEach(item=>{
      const row=node('article','layl-wishlist-item');
      if(item.image){
        const img=node('img','layl-wishlist-item-image');
        img.src=item.image;img.alt=item.title;img.loading='lazy';
        row.append(img);
      }
      const info=node('div','layl-wishlist-item-info');
      const title=node('a','layl-wishlist-item-title',item.title);title.href=item.url;info.append(title);
      if(item.price)info.append(node('span','layl-wishlist-item-price',item.price));
      const open=node('a','layl-wishlist-item-open',label('viewProduct','View product'));open.href=item.url;info.append(open);
      row.append(info);
      const remove=node('button','layl-wishlist-remove','×');remove.type='button';
      remove.setAttribute('aria-label',label('removeItemAria','Remove from favourites:')+' '+item.title);
      remove.addEventListener('click',()=>toggle(item));row.append(remove);list.append(row);
    });
  }
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-layl-wishlist-open]')){
      e.preventDefault();const d=dialog();
      if(d&&!d.open){refresh();d.showModal()}return;
    }
    if(e.target.closest('[data-layl-wishlist-close]')){
      e.preventDefault();dialog()?.close();
    }
  });
  document.addEventListener('DOMContentLoaded',()=>{
    const d=dialog();
    if(d)d.addEventListener('click',e=>{if(e.target===d)d.close()});
    decorate();
    let pending=false;
    const main=document.querySelector('#MainContent');
    if(main){
      new MutationObserver(()=>{
        if(pending)return;pending=true;
        requestAnimationFrame(()=>{pending=false;decorate()});
      }).observe(main,{childList:true,subtree:true});
    }
  });
  document.addEventListener('shopify:section:load',()=>requestAnimationFrame(decorate));
})();